import { createGlobalStyle } from "styled-components"

export const GlobalStyle = createGlobalStyle`
body{
  overflow-x: hidden;
}
  *{
    
  }
`